// Entry point. Boots the state machine and hands off to the Intro phase.
import * as Sentry from "@sentry/react";
import { initCrypto } from "./crypto";
import { createMachine } from "./state/machine";
import { createInitialContext } from "./state/context";
import { Intro } from "./phases/intro";
import { ChooseCup } from "./phases/choose-cup";
import { ChooseCharacter } from "./phases/choose-character";
import { Identify } from "./phases/identify";
import { Capture } from "./phases/capture";
import { Review } from "./phases/review";
import { Instructions } from "./phases/instructions";
import { Play } from "./phases/play";
import { Result } from "./phases/result";
import { Maintenance } from "./phases/maintenance";

Sentry.init({
  dsn: "https://29d5bd405b0d4335384ea0f9b781747a@o4508771402448896.ingest.us.sentry.io/4511850454188032",
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: []
  },
});

const root = document.getElementById("app");
if (!root) throw new Error("Missing #app root element");

// Load wasm crypto (fire-and-forget, app vẫn chạy nếu fail)
void initCrypto();

const machine = createMachine({
  root,
  context: createInitialContext(),
  phases: {
    Intro,
    ChooseCup,
    ChooseCharacter,
    Identify,
    Capture,
    Review,
    Instructions,
    Play,
    Result,
    Maintenance,
  },
});

machine.start("Intro");
